import { render, staticRenderFns } from "./ReportIndex.vue?vue&type=template&id=5748d37a&"
import script from "./ReportIndex.vue?vue&type=script&lang=js&"
export * from "./ReportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports